<template>
  <div id="pufa">
    <div class="pufaCont">
      <a href="p1/1.html" target="_blank">1、《害人害己，请不要造谣！(1)》</a>
      <a href="p2/2.html" target="_blank">2、《害人害己，请不要造谣！(2)》</a>
      <a href="p3/3.html" target="_blank">3、《害人害己，请不要造谣！(3)》</a>
      <a href="p4/4.html" target="_blank">4、《“北京地铁大爷女儿含泪发声”》</a>
      <a href="p5/5.html" target="_blank">5、《丈夫杀妻？》</a>
      <a href="p6/6.html" target="_blank">6、《学生跳河？》</a>
      <a href="p7/7.html" target="_blank">7、《打击整治网络谣言典型案例（1）》</a>
      <a href="p8/8.html" target="_blank">8、《打击整治网络谣言典型案例（2）》</a>
      <a href="p9/9.html" target="_blank">9、《打击整治网络谣言典型案例（3）》</a>
      <a href="p10/10.html" target="_blank">10、《打击整治网络谣言典型案例（4）》</a>
      <a href="p11/11.html" target="_blank">11、《打击整治网络谣言典型案例（5）》</a>
      <a href="p12/12.html" target="_blank">12、《打击整治网络谣言典型案例（6）》</a>
      <a href="p13/13.html" target="_blank">13、《打击整治网络谣言典型案例（7）》</a>
      <a href="p14/14.html" target="_blank">14、《网络水军的“水”，到底有多深？》</a>
      <a href="p15/15.html" target="_blank">15、《重拳出击严打涉网犯罪》</a>
    </div>
  </div>
</template>

<script>

import '../sass/pufa.min.css'

export default {
  name:'pufa',
  data(){
    return{
      
    }
  },
  methods:{

  },
  created(){

  },
  mounted(){

  }
}
</script>